package presentation.screens.business.home.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.Navigator
import component.image.FriendlyIcon
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import feature.businessMenu.modal.BusinessMenu
import presentation.screens.business.business_list.BusinessListScreen
import presentation.screens.business.customer.CustomerListScreen
import presentation.screens.business.employee.EmployeeListScreen
import presentation.screens.business.inventory.category.list.CategoryListScreen
import presentation.screens.business.inventory.product.BusinessInventoryProductList
import presentation.screens.business.inventory.sub_category.list.SubCategoryListScreen
import presentation.screens.business.store.MyBusinessStoreScreen
import presentation.screens.common.auth.LoginScreen

@Composable
fun menuCard(menu: BusinessMenu) {
    val navigator = LocalNavigator.current
    Card(
        modifier = Modifier
            .height(80.dp)
            .width(180.dp)
            .padding(4.dp)
            .background(color = menu.background_color!!, RoundedCornerShape(10.dp))
            .clickable {
                navigate(menu, navigator)
            },

        ) {
        Row(
            modifier = Modifier
                .padding(horizontal = 0.dp, vertical = 0.dp)
                .fillMaxWidth()
                .fillMaxHeight()
                .background(color = menu.background_color!!),
            verticalAlignment = Alignment.CenterVertically,

            ) {
            menu.icon?.let { FriendlyIcon(name = it, size = 44, padding = 8) }
            Column {
                menu.title?.let {
                    Text(
                        text = it,
                        fontSize = 15.sp,
                        textAlign = TextAlign.Center,
                    )
                }
            }
        }
    }
}

fun navigate(menu: BusinessMenu, navigator: Navigator?) {
    when (menu.target_screen) {
        "business_sale" -> {
//            navigator?.push(BusinessSale)
        }

        "business_invoice" -> {}
        "business_inventory_product" -> {
            navigateToScreen(navigator, BusinessInventoryProductList())
        }

        "business_inventory_category" -> {
            navigateToScreen(navigator, CategoryListScreen())
        }

        "business_inventory_sub_category" -> {
            navigateToScreen(navigator, SubCategoryListScreen())
        }

        "business_business_stock" -> {}
        "my_business_store" -> {
            navigateToScreen(navigator, MyBusinessStoreScreen())
        }

        "business_dashboard" -> {}
        "business_employee" -> {
            navigateToScreen(navigator, EmployeeListScreen())
        }

        "business_customers" -> {
            navigateToScreen(navigator, CustomerListScreen())
        }

        "self_business_list" -> {
            navigateToScreen(navigator, BusinessListScreen())
        }

        "inventory_product" -> {
            navigateToScreen(navigator, BusinessInventoryProductList())
        }
    }
}

fun navigateToScreen(navigator: Navigator?, screen: Screen) {
    if (AuthHandler.shared()
            .isLoggedIn() && BusinessHandler.shared().repository.business.value.Id.isEmpty()
    ) {
        navigator?.push(BusinessListScreen())
    } else if (!AuthHandler.shared().isLoggedIn()) {
        navigator?.push(LoginScreen())
    } else {
        navigator?.push(screen)
    }
}
